import styled from 'styled-components'

export const StyledAddButtom = styled.foreignObject`
    div {
        background: ${({ theme }) => theme['blue-500']};
        font-size: 12px;
        border-radius: 100px;
        height: 24px;
        padding: 2px;
        i {
            padding: 4px;
        }
        display: flex;
        justify-content: center;
        color: ${({ theme }) => theme['gray-0']};
    }
`
